export function openCalendlyPopup() {
  return () => {
    const Calendly = (window as any).Calendly;
    if (!Calendly) {
      console.warn("Calendly isn't loaded yet.");
      return;
    }
    Calendly.initPopupWidget({
      url: 'https://calendly.com/mark-wilkins-fx0m/30min',
    });
  };
}
